module.exports = __webpack_public_path__ + "static/media/ios-person.7e020058.svg";